module.exports = __webpack_public_path__ + "img/light.3dc3ae42.png";